export const formatDistanceToKm = (value: number) => {
  if (value < 0) {
    return 0
  }
  return parseFloat((value / 1000).toFixed(2))
}
export const formatTime = (item: number) => {
  const hour = Math.floor(item / 3600)
  const minute = Math.floor((item / 3600 - hour) * 60)
  const value = `${hour} ${$t('labels.hour')} ${minute > 10 ? minute : `0${minute}`} ${$t('labels.minute')}`
  return value
}
